export function sortTabsByEventTitle(eventTitle, allCategories) {
  let categories = allCategories.filter(c => c !== 'generic')
  let sortedCategories = []

  const matchers = [
    { regex: /(Birthday|Surprise|B-day|Bday)/i, cats: ['birthday', 'kidsparty'] },
    { regex: /(Graduation)/i, cats: ['graduation'] },
    { regex: /(Baby|Reveal)/i, cats: ['baby'] },
    { regex: /(Married|Wedding|Bridal|Bachelor|Save\sThe\sDate)/i, cats: ['wedding', 'bachelorette', 'bachelor'] },
    { regex: /(League|Lessons|Game|Workout|Tournament|Class|Nature|Ball)/i, cats: ['sports'] },
    { regex: /(Seminar|Talk|Conference|Call|Show|Trunk|Business|Open\sHouse|Interview|Training|Meeting|Leadership|Retreat|Board)/i, cats: ['corporate'] },
    { regex: /(Halloween)/i, cats: ['halloween'] },
    { regex: /(Thanksgiving)/i, cats: ['thanksgiving'] },
    { regex: /(Christmas|Xmas)/i, cats: ['christmas'] },
    { regex: /(New\sYear)/i, cats: ['newyearseve'] }
  ]
  matchers.forEach(({ regex, cats }) => {
    if (regex.test(eventTitle)) {
      cats.forEach(cat => {
        if (categories.includes(cat)) {
          sortedCategories.push(cat)
          categories = categories.filter(c => c !== cat)
        }
      })
    }
  })

  const now = new Date()
  const month = now.getMonth() + 1
  const day = now.getDate()

  function addIfInMonth(cat, months, extraCond = true) {
    if (categories.includes(cat) && months.includes(month) && extraCond && !sortedCategories.includes(cat)) {
      sortedCategories.push(cat)
      categories = categories.filter(c => c !== cat)
    }
  }

  addIfInMonth('halloween', [8, 9, 10])
  addIfInMonth('thanksgiving', [9, 10, 11])
  addIfInMonth('christmas', [10, 11, 12], month !== 12 || day < 26)
  addIfInMonth('newyearseve', [10, 11, 12])
  addIfInMonth('valentines', [1, 2], month !== 2 || day < 14)
  addIfInMonth('easter', [2, 3, 4], !(month === 4 && day > 12))
  addIfInMonth('mothersday', [4, 5], month !== 5 || day < 15)
  addIfInMonth('fathersday', [5, 6], month !== 6 || day < 19)
  addIfInMonth('summer', [3, 4, 5, 6, 7, 8])
  addIfInMonth('spring', [12, 1, 2, 3, 4, 5])

  const arrayOfFixedCategories = ['curatedbyhobnob', 'assorted']

  arrayOfFixedCategories.forEach(cat => {
    if (categories.includes(cat)) {
      sortedCategories.push(cat)
      categories = categories.filter(c => c !== cat)
    }
  })

  sortedCategories = sortedCategories.concat(categories)

  return sortedCategories
}
